/* Public House — motion.js
   Scroll progress, reveal-on-scroll, magnetic CTA, link peek. Respects prefers-reduced-motion. */

(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll progress hairline ---------- */
  const progress = document.querySelector('.scroll-progress');
  if (progress) {
    let ticking = false;
    const update = () => {
      const h = document.documentElement;
      const scrollable = h.scrollHeight - h.clientHeight;
      const pct = scrollable > 0 ? (h.scrollTop / scrollable) * 100 : 0;
      progress.style.setProperty('--scroll', pct + '%');
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- reveal on scroll ---------- */
  const revealers = document.querySelectorAll('[data-reveal]');
  if (revealers.length) {
    if (reduced || !('IntersectionObserver' in window)) {
      revealers.forEach((el) => el.classList.add('is-visible'));
    } else {
      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealers.forEach((el) => io.observe(el));
    }
  }

  /* ---------- magnetic CTA (eased pull toward cursor) ---------- */
  if (!reduced) {
    document.querySelectorAll('[data-magnetic]').forEach((el) => {
      const strength = parseFloat(el.dataset.magnetic) || 0.18;
      const ease = 0.12;
      let raf = 0;
      let cx = 0, cy = 0;
      let tx = 0, ty = 0;

      const tick = () => {
        cx += (tx - cx) * ease;
        cy += (ty - cy) * ease;
        if (Math.abs(tx - cx) < 0.05 && Math.abs(ty - cy) < 0.05) {
          cx = tx; cy = ty;
          el.style.transform = tx === 0 && ty === 0 ? '' : `translate(${cx}px, ${cy}px)`;
          raf = 0;
          return;
        }
        el.style.transform = `translate(${cx.toFixed(2)}px, ${cy.toFixed(2)}px)`;
        raf = requestAnimationFrame(tick);
      };

      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        tx = (e.clientX - (r.left + r.width / 2)) * strength;
        ty = (e.clientY - (r.top + r.height / 2)) * strength;
        if (!raf) raf = requestAnimationFrame(tick);
      });

      el.addEventListener('pointerleave', () => {
        tx = 0; ty = 0;
        if (!raf) raf = requestAnimationFrame(tick);
      });
    });
  }

  /* ---------- link peek (destination hint on hover) ---------- */
  const peek = document.querySelector('.link-peek');
  const peekText = peek && peek.querySelector('.link-peek__text');
  if (peek && peekText) {
    const formatHref = (href) => {
      if (!href) return '';
      if (href.startsWith('mailto:')) return href.slice(7);
      if (href.startsWith('tel:')) return href.slice(4);
      if (href.startsWith('#') || href === '') return '';
      try {
        const u = new URL(href, window.location.origin);
        const host = u.host.replace(/^www\./, '');
        const path = u.pathname === '/' ? '' : u.pathname;
        const sameOrigin = u.origin === window.location.origin;
        return sameOrigin ? (path || '/') : (host + path);
      } catch {
        return href;
      }
    };

    document.addEventListener('pointerover', (e) => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const label = formatHref(a.getAttribute('href'));
      if (!label) return;
      peekText.textContent = label;
      peek.classList.add('is-visible');
    });
    document.addEventListener('pointerout', (e) => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      if (e.relatedTarget && a.contains(e.relatedTarget)) return;
      peek.classList.remove('is-visible');
    });
    const hide = () => peek.classList.remove('is-visible');
    document.addEventListener('click', hide);
    window.addEventListener('pageshow', hide);
    window.addEventListener('pagehide', hide);
  }
})();
